export enum InvoicesListColumns {
  'ID' = 'ID',
  'TYPE' = 'Type',
  'CREATE_DATE' = 'Create Date',
  'PERIOD_DATE' = 'Period Date',
  'ACTION' = 'Action'
}
export const REPORT_TYPES = {
  FARE_CAPPING: 'fare_capping',
  POINTS_ISSUANCE: 'points_issuance'
}
export const REPORT_TYPES_TEXT = {
  FARE_CAPPING: 'Fare Capping',
  POINTS_ISSUANCE: 'Points Issuance'
}
export const INVOICES_DATE_RANGE_FORMAT = 'MM-DD-YYYY'
export const INVOICES_FILTERS_KEYS = {
  TYPE: 'selectedType'
}
export const DOWNLOAD = 'Download Report'
export const GENERATING = 'Generating Report...'
export const INVOICES_TABLE_BODY_STYLES = {
  ROW_HEIGHT: 50,
  MAX_ITEMS_PER_PAGE: 15,
  EXTRA_HEIGHT: 50,
  ROW_BORDER_BOTTOM: '1px solid #E5E7EB',
  LIST_WIDTH: '100%',
  OVER_SCAN_COUNT: 5
}
export const CELL_CONTENT = 'CellContent'

export const INVOICE_TYPE_FOR_CREATION = ['Fare Capping', 'Points Issuance']
export const INVOICE_TYPE_PARAM = {
  FARE_CAPPING: 'fare-capping',
  POINTS_ISSUANCE: 'points-issuance'
}

export const ROW_STYLE = 'flex flex-row justify-between mt-5'
export const COL_STYLE = 'flex flex-col space-y-3 w-3/6'

export const INVOICE_CREATE_KEYS = {
  FARE_CAPPING: {
    PERIOD: 'period',
    OFFERS: 'offers',
    TARGET_GROUP_ID: 'TargetGroupID'
  },
  POINTS_ISSUANCE: {
    PERIOD: 'period'
  }
}
export const INVOICES = 'Invoices'
export const INVOICE_TABS_INDEX = {
  FARE_CAPPING: { REPORT: 0 },
  POINT_ISSUANCE: {
    SUMMARY: 0,
    EARNINGS: 1,
    POINTS_AGING: 2,
    REDEMPTIONS: 3,
    REDEMPTIONS_POINTS_USAGE: 4,
    COUPONS: 5
  }
}
export const FARE_CAPPING_TABS = ['Report']
export const POINT_ISSUANCE_TABS = [
  'Summary',
  'Earnings',
  'Points Aging',
  'Redemptions',
  'Redemptions Points Usage',
  'Coupons'
]
export const CREATE_POINTS_ISSUANCE_TABS = [
  'Report Data',
  'Additional Settings'
]
export const CREATE_POINTS_ISSUANCE_TABS_INDEX = {
  REPORT_DATA: 0,
  ADDITIONAL_SETTINGS: 1
} as const

export const FARE_CAPPING_REPORT_TAB_COLUMNS = [
  'Provider',
  'Trips Participation',
  'Total Revenue Apportionment'
]
export const CREATE_INVOICE_FORM_TEXT = {
  FARE_CAPPING: {
    TITLE: 'Create a new Fare Capping Invoice Report',
    PERIOD: 'Period',
    SEGMENT: 'Segment',
    REPORT_DATE_TITLE: 'Report Data',
    REPORT_DATE_DESCRIPTION:
      'Select the dates, and the Segment that includes the specific offers that will be included on the report.',
    OFFER_LIST_TITLE:
      'List of Offers inside the Segment that were redeemed during this period:'
  },
  POINTS_ISSUANCE: {
    TITLE: 'Create a new Points Issuance Invoice Report',
    PERIOD: 'Period',
    REPORT_DATE_TITLE: 'Report Data',
    REPORT_DATE_DESCRIPTION: 'Select the dates for the report.',
    REPORT_DATE_ADDITIONAL_DESCRIPT:
      'Dates of transactions and Providers that are going to be included on the report.',
    OFFER_LIST_TITLE: 'Above and Below Offers to be included in the report:',
    CAMPAIGN_ISSUED_POINTS_LIST_TITLE:
      'Campaigns that Issue Points in the Period:',
    OTHER_CAMPAIGN_LIST_TITLE: 'Other Campaigns:',
    TOTAL_CAMPAIGN_PROVIDERS: 'Total Campaign Providers',
    ADDITIONAL_FEES_TITLE: 'Additional Fees',
    ADDITIONAL_FEES_DESCRIPTION:
      'Define the % Fees for the Providers that issued points during the selected time frame, as well as the Revenue Shared.',
    DISTRIBUTION: 'Distribution Fee (%)',
    REVENUE_DISTRIBUTION: 'Revenue Shared of Points Distribution Fee (%)',
    DISTRIBUTION_PLACE_HOLDER: 'Enter %'
  }
}
export const OFFER_LIST_COLUMNS = ['Offer', 'Listed Points', 'Real Points']
export const CAMPAIGN_LIST_COLUMNS = ['Campaign', 'Provider']

export const DATE_FORMAT_CONFIRM_POPUP = 'MMM-DD-YYYY'

export const POINTS_ISSUANCE_TABS_COLUMNS = {
  SUMMARY: ['Item', 'Points', 'USD $'],
  EARNINGS: ['Provider', 'Campaign', 'Points', 'USD $'],
  POINTS_AGING: [
    'Month',
    'Points Issued',
    'Redeemed',
    'Refunded',
    'Breakage',
    'End Balance'
  ],
  REDEMPTIONS: [
    'Offer',
    'Type',
    '# of Redemptions',
    'Total Points',
    'Total USD $',
    'Fee Rev. (USD $)',
    'COGS (USD $)'
  ],
  REDEMPTIONS_USAGE: ['Month', 'Points', 'USD $'],
  COUPONS: [
    'Offer',
    'Starting',
    'Uploaded',
    'Redeemed',
    'Available	',
    'Real Value',
    'Listed Value'
  ]
}
export const POINT_TO_DOLLAR_RATE = 100
export const REAL_VALUE_DECIMAL_POINT = 2
export const INVOICE_MONTH_FORMAT = 'MMM YYYY'
export const REPORT_TYPE_NAME = {
  POINTS_AGING: '_points_aging',
  REDEMPTIONS_USAGE: '_redemption_points_usage',
  COUPONS: '_coupons'
}
export const FIRST_COLUMN = 0
export const SECOND_COLUMN = 1

export const NON_EXIST_INDEX = -1

export const NO_DECIAML_POINT = 0

export const NO_RESULT_OFFERS = {
  POINT_ISSUANCE: 'There are no Above or Below Offers on the selected time.',
  FARE_CAPPING: 'There are no Offers assigned to the selected segment.'
}

export const NO_RESULT_CAMPAIGNS =
  'There are no transactions on the selected time.'
export const POINT_ISSUANCE_ID = {
  REVENUE_DISTRIBUTION: 'revenueDistribution'
}
export const INVOICE_REDEMPTIONS_TAB_KEYS = {
  REDEMPTIONS: 'Redemptions',
  TOTAL_POINT: 'totalPoints',
  TOTAL_USD: 'totalUSD',
  REVENUE_FEE: 'revenueFeeInUSD',
  COGS: 'COGS'
}

export const PERIOD = 'Period'
